import { render } from "./DimensionScoresBars.vue?vue&type=template&id=0c2391d9"
import script from "./DimensionScoresBars.vue?vue&type=script&lang=js"
export * from "./DimensionScoresBars.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__